module.exports = __webpack_public_path__ + "static/cover-photo-3bb9a9ded4a6df4202372c2e7509420a.png";